import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { Box, Image, Link } from '@magalu/stereo-ui/atoms';
import React, { useMemo } from 'react';
import { useInView } from 'react-intersection-observer';
import PropTypes from 'prop-types';
import Video from './AdsBrandVideo';
var AdsBrandBanner = function AdsBrandBanner(_ref) {
  var banner = _ref.banner,
    isVideo = _ref.isVideo,
    handleBrandClick = _ref.handleBrandClick,
    adsPath = _ref.adsPath,
    width = _ref.width,
    height = _ref.height,
    styles = _ref.styles;
  var inViewConfig = useMemo(function () {
    return {
      threshold: 0.5,
      triggerOnce: false
    };
  }, []);
  var _useInView = useInView(inViewConfig),
    _useInView2 = _slicedToArray(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  var bannerRedirectUrl = useMemo(function () {
    if (!(banner == null ? void 0 : banner.redirectUrl)) return null;
    try {
      var url = new URL(banner.redirectUrl);
      return url.toString();
    } catch (error) {
      console.error('invalid URL', error);
      return null;
    }
  }, [banner]);
  return React.createElement(Box, {
    ref: ref,
    style: {
      height: '100%'
    }
  }, React.createElement(Link, {
    "data-testid": "ads-brand-banner",
    href: bannerRedirectUrl,
    style: {
      display: 'block',
      height: '100%'
    },
    onMouseDown: handleBrandClick,
    onClick: function onClick(e) {
      return e.preventDefault();
    }
  }, isVideo ? React.createElement(Video, {
    adsPath: adsPath,
    banner: banner,
    height: height,
    inView: inView,
    width: width,
    styles: styles
  }) : React.createElement(Image, {
    src: banner.imageUrl,
    style: _extends({}, styles, {
      height: height,
      objectFit: 'fill',
      width: width
    })
  })));
};
AdsBrandBanner.defaultProps = {
  adsPath: '',
  banner: {},
  handleBrandClick: function handleBrandClick() {},
  height: 0,
  isVideo: false,
  styles: {},
  width: 0
};
process.env.NODE_ENV !== "production" ? AdsBrandBanner.propTypes = {
  adsPath: PropTypes.string,
  banner: PropTypes.shape({
    imageUrl: PropTypes.string,
    redirectUrl: PropTypes.string,
    trackId: PropTypes.string
  }),
  handleBrandClick: PropTypes.func,
  height: PropTypes.number,
  isVideo: PropTypes.bool,
  styles: PropTypes.shape({}),
  width: PropTypes.number
} : void 0;
AdsBrandBanner.ssr = true;
export default AdsBrandBanner;